import { userFields } from '@openx/components-administration/lib/constants.ts';
import type { TFunction } from 'i18next';
import { object, string } from 'yup';

export const getValidationSchema = (t: TFunction) =>
  object().shape({
    [userFields.ACCOUNT]: string().required(t('Organization is required')),
    [userFields.EMAIL]: string().email(t('Please enter a valid email address')).required(t('Email is required')),
    [userFields.FIRST_NAME]: string().required(t('First Name is required')),
    [userFields.LAST_NAME]: string().required(t('Last Name is required')),
  });
